/** Typy natiahnutia */
export enum DrawTypes {

  hold = 'hold',
  bar = 'bar'

}